import { dbStorage } from './indexedDBStorage'
import { safeStorageGet, safeStorageSet } from './safeStorage'

export const getPersistedUiPreference = async (key: string): Promise<string> => {
  if (!key) {
    return ''
  }

  const localValue = safeStorageGet(key)
  if (localValue) {
    return localValue
  }

  try {
    return await dbStorage.getUiPreference(key)
  } catch {
    return ''
  }
}

export const setPersistedUiPreference = async (key: string, value: string): Promise<boolean> => {
  if (!key) {
    return false
  }

  const localPersisted = safeStorageSet(key, value)

  try {
    await dbStorage.setUiPreference(key, value)
    return true
  } catch {
    return localPersisted
  }
}
